import React, { useState, useEffect } from 'react';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib = {};
var useScript$1 = {};

(function (exports) {
  var __rest = commonjsGlobal && commonjsGlobal.__rest || function (s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.scripts = void 0;
  var react_1 = React; // Previously loading/loaded scripts and their current status

  exports.scripts = {}; // Check for existing <script> tags with this src. If so, update scripts[src]
  // and return the new status; otherwise, return undefined.

  var checkExisting = function checkExisting(src) {
    var existing = document.querySelector("script[src=\"" + src + "\"]");

    if (existing) {
      // Assume existing <script> tag is already loaded,
      // and cache that data for future use.
      return exports.scripts[src] = {
        loading: false,
        error: null,
        scriptEl: existing
      };
    }

    return undefined;
  };

  function useScript(_a) {
    var src = _a.src,
        _b = _a.checkForExisting,
        checkForExisting = _b === void 0 ? false : _b,
        attributes = __rest(_a, ["src", "checkForExisting"]); // Check whether some instance of this hook considered this src.


    var status = src ? exports.scripts[src] : undefined; // If requested, check for existing <script> tags with this src
    // (unless we've already loaded the script ourselves).

    if (!status && checkForExisting && src && isBrowser) {
      status = checkExisting(src);
    }

    var _c = (0, react_1.useState)(status ? status.loading : Boolean(src)),
        loading = _c[0],
        setLoading = _c[1];

    var _d = (0, react_1.useState)(status ? status.error : null),
        error = _d[0],
        setError = _d[1];

    (0, react_1.useEffect)(function () {
      // Nothing to do on server, or if no src specified, or
      // if loading has already resolved to "loaded" or "error" state.
      if (!isBrowser || !src || !loading || error) return; // Check again for existing <script> tags with this src
      // in case it's changed since mount.
      // eslint-disable-next-line react-hooks/exhaustive-deps

      status = exports.scripts[src];

      if (!status && checkForExisting) {
        status = checkExisting(src);
      } // Determine or create <script> element to listen to.


      var scriptEl;

      if (status) {
        scriptEl = status.scriptEl;
      } else {
        scriptEl = document.createElement('script');
        scriptEl.src = src;
        Object.keys(attributes).forEach(function (key) {
          if (scriptEl[key] === undefined) {
            scriptEl.setAttribute(key, attributes[key]);
          } else {
            scriptEl[key] = attributes[key];
          }
        });
        status = exports.scripts[src] = {
          loading: true,
          error: null,
          scriptEl: scriptEl
        };
      } // `status` is now guaranteed to be defined: either the old status
      // from a previous load, or a newly created one.


      var handleLoad = function handleLoad() {
        if (status) status.loading = false;
        setLoading(false);
      };

      var handleError = function handleError(error) {
        if (status) status.error = error;
        setError(error);
      };

      scriptEl.addEventListener('load', handleLoad);
      scriptEl.addEventListener('error', handleError);
      document.body.appendChild(scriptEl);
      return function () {
        scriptEl.removeEventListener('load', handleLoad);
        scriptEl.removeEventListener('error', handleError);
      }; // we need to ignore the attributes as they're a new object per call, so we'd never skip an effect call
    }, [src]);
    return [loading, error];
  }

  exports.default = useScript;
  var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
})(useScript$1);

(function (exports) {
  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.scripts = exports.default = void 0;
  var use_script_1 = useScript$1;
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function get() {
      return __importDefault(use_script_1).default;
    }
  });
  Object.defineProperty(exports, "scripts", {
    enumerable: true,
    get: function get() {
      return use_script_1.scripts;
    }
  });
})(lib);

var useScript = /*@__PURE__*/getDefaultExportFromCjs(lib); // This is where GoCardless hosts the Dropin initialise script. Compatibility is
// guaranteed across the same major version- no one should be trying to use a different
// version of this script with the React bindings!

var GOCARDLESS_DROPIN_INITIALISE_URL = "https://pay.gocardless.com/billing/static/dropin/v2/initialise.js"; // eslint-disable-next-line

var noop = function noop() {};

var useGoCardlessDropin = function useGoCardlessDropin(options) {
  // Asynchronously load the initialise script. This should make GoCardlessDropin
  // available on window.
  var initialiseURL = options.initialiseURL || GOCARDLESS_DROPIN_INITIALISE_URL;

  var _a = useScript({
    src: window.GoCardlessDropin ? null : initialiseURL,
    checkForExisting: true
  }),
      loading = _a[0],
      scriptLoadError = _a[1];

  var _b = useState(scriptLoadError),
      error = _b[0],
      setError = _b[1];

  var _c = useState(undefined),
      handler = _c[0],
      setHandler = _c[1];

  useEffect(function () {
    // If the link.js script is still loading, return early
    if (loading) {
      return;
    } // We have an error loading the script, but we've already given this to our caller via
    // the error result. We should not try to recover, as we can't recover from this.


    if (scriptLoadError) {
      setError(scriptLoadError);
      return;
    } // We have finished loading and there was no error, so something really terrible has
    // happened if we don't have the GoCardlessDropin available on window.
    //
    // This probably means we've loaded a corrupt or broken initialise script? We should
    // provide an error that suggests there is a problem with the script.


    if (!window.GoCardlessDropin) {
      setError(new ErrorEvent("error loading GoCardless Dropin initialise script from " + (initialiseURL + ": failed to find window.GoCardlessDropin after load!")));
      return;
    } // If we already have a handler, then the Dropin is open. But we've changed our state,
    // which means we need to start over!
    //
    // Call exit() to close the old handler before we attempt to create a new one.


    if (handler) {
      handler.exit();
    } // Create a new handler, and set it in our state. The responsibility is on the caller
    // to call the open function- until then, the Dropin will be invisible.


    setHandler(window.GoCardlessDropin.create(options));
  }, [loading, scriptLoadError, options.billingRequestFlowID, setError]);
  return {
    error: error === null ? undefined : error,
    ready: !!handler,
    exit: (handler === null || handler === void 0 ? void 0 : handler.exit) || noop,
    open: (handler === null || handler === void 0 ? void 0 : handler.open) || noop
  };
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
}; // Opens a Billing Request Flow in a modal. Relies on GoCardlessDropin being
// loaded into window, which will only happen if the initialise script has been
// loaded via a script tag.


var GoCardlessDropinButton = function GoCardlessDropinButton(props) {
  var open = useGoCardlessDropin(_assign({}, props)).open;
  return React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return open();
    }
  }, "Start Dropin for ", React.createElement("code", null, props.billingRequestFlowID), " in", " ", React.createElement("code", null, props.environment));
};

export { GoCardlessDropinButton, useGoCardlessDropin };